@switch (view) {
  @case (views.SmsOptIn) {
    <app-account-sms-opt-in
      [phoneNumber]="savedProfile.phoneNumber"
      (cancelled)="returnToSettings(tabIds.Alerts)"
      (codeSent)="onSmsCodeSent($event)"
    ></app-account-sms-opt-in>
  }
  @case (views.SmsVerify) {
    @if (smsConsent) {
      <app-account-sms-verify
        [phoneNumber]="phoneNumberDisplay"
        [consent]="smsConsent"
        (cancelled)="returnToSettings(tabIds.Alerts)"
        (changeNumber)="openSmsOptIn()"
        (verified)="onSmsVerified()"
      ></app-account-sms-verify>
    }
  }
  @case (views.TwoFactor) {
    <app-account-two-factor-otp
      [disabling]="twoFactorDisabling"
      (cancelled)="returnToSettings(tabIds.Security)"
      (verified)="onTwoFactorVerified()"
    ></app-account-two-factor-otp>
  }
  @case (views.ChangePassword) {
    <app-account-change-password
      (cancelled)="returnToSettings(tabIds.Security)"
      (updated)="onPasswordUpdated()"
    ></app-account-change-password>
  }
  @default {
    <section class="settings" role="dialog" aria-modal="true" aria-labelledby="account-settings-title">
      <header class="settings-head">
        <div class="avatar" aria-hidden="true">{{ initials }}</div>
        <div class="settings-title">
          <h1 id="account-settings-title">{{ 'Account settings' | translate }}</h1>
          <span class="identity">{{ draft.fullName }} · {{ draft.userName }}</span>
          <div class="meta">
            <app-account-inline-edit-chip
              class="phone-chip"
              icon="phone"
              inputType="tel"
              [label]="'Phone' | translate"
              [placeholder]="'Phone number' | translate"
              [editLabel]="'Edit phone' | translate"
              [saveLabel]="'Save phone' | translate"
              [value]="savedProfile.phoneNumber"
              [saveFn]="savePhoneNumber"
            ></app-account-inline-edit-chip>
            <app-account-inline-edit-chip
              class="job-title-chip"
              icon="briefcase"
              [label]="'Job title' | translate"
              [editLabel]="'Edit job title' | translate"
              [saveLabel]="'Save job title' | translate"
              [maxLength]="jobTitleMaxLength"
              [value]="savedProfile.jobTitle"
              [saveFn]="saveJobTitle"
            ></app-account-inline-edit-chip>
          </div>
        </div>
        <button type="button" class="icon-btn close-btn" [attr.aria-label]="'Close' | translate" (click)="cancel()">
          <app-account-icon name="x"></app-account-icon>
        </button>
      </header>

      <div class="settings-body">
        <nav class="as-side" role="tablist" aria-orientation="vertical" [attr.aria-label]="'Settings sections' | translate">
          @for (tab of tabs; track trackById($index, tab)) {
            <button
              type="button"
              role="tab"
              class="nav-btn"
              [id]="'account-tab-' + tab.id"
              [attr.aria-selected]="tab.id === activeTab"
              [attr.aria-controls]="'account-panel-' + tab.id"
              (click)="selectTab(tab.id)"
            >
              <app-account-icon [name]="tab.icon"></app-account-icon>
              {{ tab.name | translate }}
            </button>
          }
        </nav>

        <div
          class="content"
          role="tabpanel"
          [id]="'account-panel-' + activeTab"
          [attr.aria-labelledby]="'account-tab-' + activeTab"
        >
          @switch (activeTab) {
            @case (tabIds.Alerts) {
              <app-account-alerts-tab
                [email]="draft.userName"
                [emailEnabled]="emailEnabled"
                [smsEnabled]="smsEnabled"
                [hasPhoneNumber]="hasPhoneNumber"
                [phoneVerified]="phoneVerified"
                [phoneNumberDisplay]="phoneNumberDisplay"
                (emailToggled)="toggleEmailAlerts()"
                (smsToggled)="toggleSmsAlerts()"
                (manageNumber)="openSmsOptIn()"
              ></app-account-alerts-tab>
            }
            @case (tabIds.RegionTime) {
              <app-account-region-tab
                [timezones]="timezones"
                [languages]="languages"
                [timeFormats]="timeFormats"
                [dateFormats]="dateFormats"
                [timeZoneId]="draft.timeZoneId"
                [languagePreference]="draft.languagePreference"
                [timePreference]="draft.timePreference"
                [datePreference]="draft.datePreference"
                [locationDisplay]="locationDisplay"
                (changed)="applyChange($event)"
                (setLocation)="openLocationPicker()"
              ></app-account-region-tab>
            }
            @case (tabIds.Units) {
              <app-account-units-tab
                [units]="units"
                [profile]="draft"
                (changed)="applyChange($event)"
              ></app-account-units-tab>
            }
            @case (tabIds.Security) {
              <app-account-security-tab
                [twoFactorEnabled]="draft.twoFactorEnabled"
                [mfaLocked]="mfaLocked"
                [twoFactorBusy]="twoFactorBusy"
                (changePassword)="openChangePassword()"
                (twoFactorToggled)="onTwoFactorToggle()"
              ></app-account-security-tab>
            }
          }
        </div>
      </div>

      <footer class="settings-foot">
        <button type="button" class="as-btn-secondary cancel-btn" (click)="cancel()">
          {{ 'Cancel' | translate }}
        </button>
        <button type="button" class="as-btn-primary save-btn" [disabled]="isSaving" (click)="save()">
          {{ 'Save changes' | translate }}
        </button>
      </footer>
    </section>
  }
}
